var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('section',[_c('h1',[_vm._v(_vm._s(_vm.$t('cookiesPolicyPage.cookiesPolicy')))]),_c('div',{staticClass:"cookies-container"},[_c('div',{ref:"cookieDeclaration"})])]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }